(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("VueCurrencyFilter", [], factory);
	else if(typeof exports === 'object')
		exports["VueCurrencyFilter"] = factory();
	else
		root["VueCurrencyFilter"] = factory();
})(global, function() {
return 